import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from 'vue';
import BaseTable from "@/components-UI/table/BaseTable.vue";
import BaseEditableCard from "@/components-UI/BaseEditableCard.vue";
import { RawConfig, prepareItems, CellsType } from "@/utils/CellsFactory";
import { ITableHeader, showServerError } from "@/utils";
import { translateChargeRequestStatus } from "@/utils/translate";
import { getChargeRequestsV2 } from "@/api/payout";
import BaseButtonV2 from "@/components-UI/buttons/BaseButtonV2.vue";
import { useRouter } from "vue-router/composables";
import { IAffiliateInvoice } from "@/api/types/payout";


export default /*#__PURE__*/_defineComponent({
  __name: 'AffiliateChargeRequests',
  props: {
    invoice: null
  },
  setup(__props: any) {

const props = __props as {
    invoice: IAffiliateInvoice,
}



const tableLoading = ref(false);
const tableHeaders: ITableHeader[] = [
    { text: 'ID заявки', value: 'id' },
    { text: 'Внешний ID', value: 'code' },
    { text: 'Проект', value: 'project', width: 'max-content' },
    { text: 'Наша организация', value: 'organization' },
    { text: 'К выплате', value: 'amount', align: 'right' },
    { text: 'Комиссия', value: 'commission', align: 'right' },
    { text: 'Итого', value: 'total_amount', align: 'right' },
    { text: 'Выплачено по счёту', value: 'payout_method', align: 'right' },
    { text: 'Способ выплаты', value: 'contractor', width: 'max-content' },
    { text: 'Реквизиты', value: 'requisites', width: 'max-content' },
    { text: 'ФИО создателя заявки', value: 'creator' },
    { text: 'Дата создания заявки', value: 'created_at', align: 'right' },
    { text: 'Дата обновления заявки', value: 'updated_at', align: 'right' },
    { text: 'Статус заявки', value: 'status' },
];
const tableConfig: RawConfig<any> = {
    [CellsType.Route]: {
        id: {
            name: 'charge-request',
            valueKey: 'id',
            text: 'id',
            isChip: true,
        },
    },
    [CellsType.Text]: {
        creator: {
            template: (el) => `${el.creator.first_name} ${el.creator.last_name}`,
        },
    },
    [CellsType.Number]: {
        amount: {
            currency: (c) => c.currency,
            isSymbolCurrency: true,
            noWrap: true,
        },
        commission: {
            value: (i) => (i.commission * 100).toFixed(2),
            currency: '%',
        },
        total_amount: {
            currency: (c) => c.currency,
            isSymbolCurrency: true,
            noWrap: true,
        },
        payout_method: {
            value: (v) => {
                const findInvoice = v.invoices.find(el => el.invoice_id === Number(getCurrentId.value));
                return findInvoice ? Number(findInvoice.paid).toLocaleString('ru-RU', {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                }) : '';
            },
            currency: () => props.invoice.currency,
            isSymbolCurrency: true,
            noWrap: true,
        },
    },
    [CellsType.Date]: {
        created_at: {},
        updated_at: {},
    },
    [CellsType.Status]: {
        status: {
            translate: (s) => translateChargeRequestStatus(s),
        },
    },
};

const router = useRouter();
const tableItems = ref([]);
const tableTotalCount = ref(0);
const tableLimitCount = ref(10);

const getCurrentId = computed<string>(() => router.currentRoute.params.id);

const fetchChargeRequests = async (offset: number): Promise<void> => {
    try {
        tableLoading.value = true;

        const { meta, data } = await getChargeRequestsV2({
            invoice_ids: [getCurrentId.value],
            limit: tableLimitCount.value,
            offset,
        });
        tableTotalCount.value = meta?.total;
        prepareTableItems(data);
    } catch (e) {
        showServerError(e, 'Список заявок на расход не загружен');
    } finally {
        tableLoading.value = false;
    }
};

const prepareTableItems = <T>(items: T[]): void => {
    const columns = tableHeaders.map(el => el.value);
    tableItems.value = prepareItems(items, tableConfig, columns);
};

const redirect = () => {
    router.push({ name: 'charge-requests' });
};

onMounted(async () => {
    await fetchChargeRequests(0);
});

return { __sfc: true,props, tableLoading, tableHeaders, tableConfig, router, tableItems, tableTotalCount, tableLimitCount, getCurrentId, fetchChargeRequests, prepareTableItems, redirect, BaseTable, BaseEditableCard, BaseButtonV2 }
}

})